<div class="support-assign-form">
    <div>
        <h2>Aktion auswählen</h2>
        <p>Wie möchten Sie mit diesem Ticket verfahren?</p>
    </div>
    
    <div class="form-actions">
        <afs-button type="outline" color="danger" (click)="ticketRejectModal.show()">Anfrage ablehnen</afs-button>
        <afs-button (click)="openAssignModal()">Akzeptieren & Zuweisen</afs-button>
    </div>
</div>



<afs-modal #ticketRejectModal title="Anfrage ablehnen" [maxWidth]="450">

    <p>
        Es wird empfohlen, eine Begründung anzugeben, um Missverständnisse zu vermeiden.
        Sofern eingestellt, erhält der Kunde diese Begründung als E-Mail.
    </p>

    <label>Begründung (optional)</label>
    <afs-input-textarea [(ngModel)]="rejectMessage" placeholder="Ablehnung weil..."></afs-input-textarea>

    <div class="afs-modal-footer">
        <afs-button [fullWidth]="true" color="danger" (click)="rejectRequest()">Abfrage ablehnen</afs-button>
    </div>
</afs-modal>

<afs-modal #ticketAssignModal title="Ticket zuweisen" [maxWidth]="450" (onClose)="supportAssign.clear()">
    <support-assign #supportAssign [inputTicketType]="ticketSrv.ticketArt?.id"></support-assign>

    <div class="afs-modal-footer">
        <afs-button [fullWidth]="true" [disabled]="!supportAssign.isValid" (click)="assignTicketRequest(supportAssign.selectedEmployeeIds, supportAssign.selectedTicketType)">Akzeptieren & Zuweisen</afs-button>
    </div>
</afs-modal>